import {
  Button,
  capitalize,
  Card,
  DialogActions,
  Skeleton,
} from "@mui/material";
import {
  classes,
  RED_LOADING_BUTTON,
  TEXT_FIELD_DARK,
} from "portal/theme/theme";
import { Field, Form, Formik } from "formik";
import { object, string } from "yup";
import { portalApi } from "portal/state/portalApi";
import { t } from "i18next";
import { TextField } from "formik-mui";
import { titleCase } from "portal/utils/strings";
import {
  useCanUpdatePortalGlobals,
  withPortalGlobalsReadAccess,
} from "portal/views/plantProfiles/permissions";
import {
  useMutationPopups,
  useQueryPopups,
} from "portal/utils/hooks/useApiPopups";
import React, { FC } from "react";

interface AdminModelSelector {
  className?: string;
}
export const _AdminModelSelector: FC<AdminModelSelector> = ({ className }) => {
  const editable = useCanUpdatePortalGlobals();

  const { data: globalValues, isLoading } = useQueryPopups(
    portalApi.endpoints.getGlobals.useQuery()
  );
  const [saveGlobals] = useMutationPopups(
    portalApi.endpoints.setGlobals.useMutation(),
    {
      success: capitalize(
        t("utils.actions.savedLong", {
          subject: titleCase(t("models.globals.global_one")),
        })
      ),
    }
  );

  const initialValues = {
    plantProfileModelId: globalValues?.plantProfileModelId ?? "",
  };
  return (
    <Card className={classes(className, "p-4 pt-6")}>
      {isLoading || !globalValues ? (
        <Skeleton variant="rectangular" height="3rem" />
      ) : (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={object({
            plantProfileModelId: string(),
          })}
          onSubmit={async (values) => {
            if (editable) {
              await saveGlobals({
                globals: values,
                updateMask: ["plantProfileModelId"],
              });
            }
          }}
        >
          {({ submitForm, isSubmitting, dirty, resetForm }) => {
            return (
              <Form className="flex justify-between flex-wrap gap-4">
                <Field
                  {...TEXT_FIELD_DARK}
                  component={TextField}
                  name="plantProfileModelId"
                  label={t("models.globals.values.plantProfileModelId.label")}
                  helperText={t(
                    "models.globals.values.plantProfileModelId.description"
                  )}
                  className="w-1/2 min-w-64"
                  slotProps={{
                    input: {
                      className: "font-mono text-xs w-full",
                    },
                  }}
                  disabled={!editable}
                />
                {editable && (
                  <DialogActions>
                    <Button
                      variant="text"
                      className="text-white"
                      disabled={isSubmitting}
                      onClick={() => {
                        resetForm();
                      }}
                    >
                      {t("utils.actions.cancel")}
                    </Button>
                    <Button
                      {...RED_LOADING_BUTTON}
                      disabled={!dirty}
                      loading={isSubmitting}
                      onClick={() => {
                        submitForm();
                      }}
                    >
                      {t("utils.actions.save")}
                    </Button>
                  </DialogActions>
                )}
              </Form>
            );
          }}
        </Formik>
      )}
    </Card>
  );
};

export const AdminModelSelector =
  withPortalGlobalsReadAccess(_AdminModelSelector);
